// extracted by mini-css-extract-plugin
export var disclaimerText = "disclaimer-module--disclaimer-text--cddb8";
export var disclaimerWrapper = "disclaimer-module--disclaimer-wrapper--7bef3";